import styled, { css } from 'styled-components'
import { rgba } from 'polished'

// Utils
import { breakpoint } from 'utils'

export const Divider = styled.div`
  display: flex;
  margin: 0 8px;
  color: ${({ theme }) => theme.colors.state.disabled};
`

interface ItemProps {
  $isActive: boolean
  $showAllInMobile?: boolean
  $isLink?: boolean
}

export const Item = styled.li<ItemProps>(
  ({ theme, $isActive, $showAllInMobile, $isLink }) => css`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 0.8125rem;
    opacity: ${$isActive ? '1' : '0.5'};
    pointer-events: ${$isActive ? 'none' : 'auto'};
    cursor: ${$isLink ? 'pointer' : 'default'};

    &:last-child {
      ${Divider} {
        display: none;
      }
    }

    &::before {
      content: counter(steps);
      counter-increment: steps;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 21px;
      height: 18px;
      margin-right: 8px;
      font-size: ${theme.fontSizes.tiny};
      font-weight: ${theme.fontWeights.bold};
      color: ${theme.colors.white};
      margin-bottom: 2px; /* stylelint-disable-line scales/space */
      background-color: ${$isActive
        ? theme.colors.primaryTint[100]
        : rgba(theme.colors.black, 1)};
      border-radius: ${theme.radii.rounded};

      /* Helps center the digit in the pill */
      line-height: 2;
      letter-spacing: 0;
    }

    ${breakpoint('base', 'sm')`
      ${
        !$showAllInMobile &&
        !$isActive &&
        css`
          width: 0;
          overflow: hidden;
        `
      }

      ${
        !$showAllInMobile &&
        css`
          ${Divider} {
            display: none;
          }
        `
      }
    `}
  `
)
